import { CheckCircle } from 'lucide-react';

import { detectMidTurnCompaction } from '@/features/votes/parseChatHistory';

import CollapsibleBlock from '../CollapsibleBlock';

export default function ToolResultField({ value }: { value: string }) {
  let resultData: { func_name?: string; result: string } | null = null;
  try {
    const parsed = JSON.parse(value);
    resultData = {
      func_name: parsed.func_name,
      result: String(parsed.result ?? ''),
    };
  } catch {
    resultData = null;
  }

  const rawResult = resultData?.result ?? value;
  const compaction = detectMidTurnCompaction(rawResult);
  const summary = [resultData?.func_name, `${rawResult.length} chars`]
    .filter(Boolean)
    .join(' · ');

  return (
    <CollapsibleBlock
      icon={<CheckCircle className="h-3.5 w-3.5" />}
      label="Tool Result"
      summary={summary}
      tone="green"
    >
      {compaction && (
        <div className="mb-2 inline-flex items-center rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
          {compaction === 'summary'
            ? '🗜 Mid-turn compaction summary'
            : '🗜 Compacted mid-turn'}
        </div>
      )}
      <div className="max-h-64 overflow-y-auto whitespace-pre-wrap break-words font-mono text-xs text-muted-foreground">
        {rawResult}
      </div>
    </CollapsibleBlock>
  );
}
